module.exports = __webpack_public_path__ + "img/c1.868710e5.jpg";